import { useGroupNameValue } from "@/shared/client";
import { Center, Flex, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { FONT, MEDIA } from "@styles/common";
import { Link } from "react-router-dom";

export const Footer = () => {
    const groupName = useGroupNameValue();
    const { isMobile } = MEDIA();

    return (
        <Center p={isMobile ? "64px 16px" : "64px 16px 128px"}>
            <Flex maxWidth="1600px" w="100%" flexDir="column" gap="16px" alignItems="center">
                <CustomText>
                    주식회사 <CustomLinkTo to="https://marginmax.kr">{groupName}</CustomLinkTo>는 통신판매중개자로서
                    예약시스템만 제공하며, 예약 관련 서비스는 숙박업체의 책임하에 운영되고있습니다.
                </CustomText>
                <Flex columnGap="8px">
                    <CustomText>
                        <a
                            href="http://marketingmax.net/privacy.html"
                            target="_blank"
                            style={{ fontSize: "14px" }}
                            rel="noreferrer"
                        >
                            개인정보처리방침
                        </a>
                    </CustomText>
                    <CustomText>
                        <a
                            href="http://marketingmax.net/agree.html"
                            target="_blank"
                            style={{ fontSize: "14px" }}
                            rel="noreferrer"
                        >
                            전자상거래 이용약관
                        </a>
                    </CustomText>
                </Flex>
            </Flex>
        </Center>
    );
};

const CustomText = styled(Text)`
    ${FONT("pretendard", 16, 300, 1.5)};
    color: ${({ theme }) => theme.COLOR.gray[500]};

    & a {
        text-decoration: underline;
    }
`;

const CustomLinkTo = styled(Link)`
    ${FONT("pretendard", 16, 700, 1.5)};
    text-decoration: underline;
`;
